/** Appends the total in parentheses, e.g. "Systems per Life Cycle (12)". */
export const withTotalInTitle = (title: string, total: number) =>
  `${title} (${total})`;
